module.exports = __webpack_public_path__ + "static/media/uncharted-logo.bbbf8d57.png";